import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyProfileComponent } from './profile/profile.component';
import { ProfileModule } from 'profile';
import { HelpComponent } from './help/help.component';
import { ApplicationComponent } from './application/application.component';
import { DhhpComponentModule } from '../../shared/dhhp-component.module';
import { AppManagerModule } from 'app-manager';



@NgModule({
  declarations: [
    MyProfileComponent,
    HelpComponent,
    ApplicationComponent
  ],
  imports: [
    DhhpComponentModule,
    CommonModule,
    ProfileModule,
    AppManagerModule
  ],
  exports: [
    MyProfileComponent,ApplicationComponent
  ]
})
export class GlobalNavPanelModule { }
